import React from 'react';

// Components
import Webcam from '../UserMedia/Webcam';

const RoomScan = class RoomScan extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.complete = this.complete.bind(this);
    this.showExampleVideo = this.showExampleVideo.bind(this);

    // Set the initial state
    this.state = {
      ready: false,
      mediaChecked: false,
      getUserMedia: true,
    };
  }

  componentDidUpdate() {
    const { button, parent, sessionStartData, statusClass } = this.props;
    if(statusClass === 'slide-active') {
      if(!sessionStartData.modalityOptions.roomScan) {
        parent.nextStep();
      }

      if(!button.disabled && !this.state.finished) {
        // Disable the continue button
        button.disabled = true;

        parent.setState({
          next: null
        });
      }
    }
  }

  complete() {
    const { button, parent, nextStep } = this.props;

    this.setState({
      finished: true
    });

    button.disabled = false;

    parent.setState({
      next: nextStep
    });
  }

  showExampleVideo(e) {
    const { SessionStore } = this.props.store;
    const lastFocused = e.target;

    const example = (
      <div className="vid__wrap vid__wrap--wide">
        <iframe
          title="Example Video of a Room Scan - No audio"
          src="https://player.vimeo.com/video/240038653?byline=0&portrait=0&autoplay=1"
          className="vid__video"
          width="640"
          height="360"
          frameBorder="0"
          allow="autoplay; fullscreen"
          allowFullScreen
        />
      </div>
    );
    
    SessionStore.showModal = true;
    SessionStore.modalContent = example;
    SessionStore.modalLoaded = true;
    SessionStore.lastFocused = lastFocused;
  }

  render() {
    const { onStart, onStop, statusClass } = this.props;
    const translation = this.props.translation.room_scan;

    return (
      <main className={`panel panel--medium ${statusClass}`} aria-labelledby="step6">
        <h2 className="panel__title panel__title--alt" id="step6"> 
          {translation.heading}
        </h2>

        <p>
          {translation.body} 
          <button
            className="btn--link"
            onClick={(e) => this.showExampleVideo(e)}
          >
            {translation.example}
          </button>
        </p>

        {statusClass === 'slide-active' &&
          <Webcam
            {...this.props}
            allowRecord={true}
            camera="user"
            parent={this}
            disableFullScreen={true}
            callback={this.complete}
            recordStart={onStart}
            recordStop={onStop}
          />
        }
      </main>
    )
  }
}

export default RoomScan;



// WEBPACK FOOTER //
// ./src/app/components/SessionStart/RoomScan.js